module.exports = __webpack_public_path__ + "static/media/heartemoji.e04f22d7.png";